// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"7bfff672","729":"cb1fa7a9"}[chunkId] + ".css";
};